module.exports = __webpack_public_path__ + "static/media/rike-first-button.121abdad.png";